/*
 * @Descripttion: 系统常量
 * @version: 1.0
 * @Author: fxj
 * @Date: 2021-11-29 15:38:25
 * @LastEditors: Songtutu
 * @LastEditTime: 2025-02-27 20:42:21
 */
const config ={
  http:{
    olypusHttp:{
      baseURL : '',
      systemURL : '/business-system/web-olympus-center',
      chargeURL: '/saas-charge/web-saas-center',
      commonURL: '/saas-common/web-saas-center'
    },
    otherHttp:{
    }
  }
}

export default config